export const getFlagText = (item) => {
  if (item["__typename"].toLowerCase() === "bundleproduct") {
    if (item?.simplebundle) {
      return item?.flag_text;
    }
    return "";
  } else {
    return item?.flag_text;
  }
};
